import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

import ValidatorSeePage from "./ValidatorSubmittedSee";

import { GET_VALIDATOR_ACCEPTED_CI, } from "../../AppConstant";

function ValidatorSubmitted({ userDetails, setParentLoading }) {

    const [isValidated, setIsValidated] = useState(false); 
    const [submitted, setSubmitted] = useState([]);
    const [commentName, setCommentName] = useState("");
    const [selectedItem, setSelectedItem] = useState("");

    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSeeModal, setShowSeeModal] = useState(false);

    const getSubmitted = async () => {

        try {
            setParentLoading(true);
            const emailid = localStorage.getItem("emailid");

            const res = await axios.get(GET_VALIDATOR_ACCEPTED_CI, {
                params: { "validatoremail": emailid }
            });
            setSubmitted(res.data);
            console.log("API response:", res.data);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    const handleOpenSeeModal = async (item) => {
        localStorage.setItem('swipexid', item.id)
        localStorage.setItem('swipexempid', item.empid)

        if(item.isvalidatorapproved == "approved" || item.isvalidatorapproved == "rejected" || item.status == "F" || item.status == "A" || item.status == "U"){
            setIsValidated(true);
        }else{
            setIsValidated(false);
        }

        setParentLoading(true);
        setShowSeeModal(true);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseSeeModal = () => {
        setParentLoading(true);
        setShowSeeModal(false);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    useEffect(() => {
        getSubmitted();
    }, []);


     const [searchTerm, setSearchTerm] = useState("");
        
            const filteredRecords = submitted.filter((item) => {
            const searchableText = [
                ...Object.values(item),
            ]
                .join(" ")
                .toLowerCase();
        
            return searchableText.includes(searchTerm.toLowerCase());
        });

        const [expandedComment, setExpandedComment] = useState(null);
                
                const handleSeeMore = (index) => {
                  setExpandedComment(expandedComment === index ? null : index);
                };

    return (
        <div>

 <div className="input-group mb-3" style={{ width: "500px" }}>
    <span className="input-group-text">
        <i className="bi bi-search"></i>
    </span>

    <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
    />
</div>

             <table className="mt-1 fw-bold" style={{fontSize:"small"}}>
                <thead className="bg-success-subtle" style={{ width:"100%", color:"green" }} >
                    <tr style={{width:"3%"}}>
                        <th style={{width:"5%"}}>S.No</th>
                        <th style={{width:"15%"}}>SWIPEX ID</th>
                        <th style={{width:"10%"}}>EMPLOYEE ID</th>
                        <th style={{width:"15%"}}>EMPLOYEE NAME</th>
                        <th style={{width:"20%"}}>TITLE </th>
                        <th style={{width:"11%"}}>ACTION</th>
                        <th style={{width:"12%"}}>CREATED AT</th>
                        <th style={{width:"12%"}}>ACCEPTED AT</th>
                    </tr>
                </thead>

                <tbody className="text-white" style={{ fontSize: "small" }}>
                    {filteredRecords.length > 0 ? (
                        filteredRecords.map((sub, index) => (
                            <tr key={sub.id}>

                                <td>{index + 1}</td>
                                <td>{sub.id}</td>
                                <td>{sub.empid}</td>
                                <td>{sub.empname}</td>
                                <td>{sub.title}</td>

                                <td>
                                    <div className="d-flex justify-content-center fw-bold" style={{ fontSize: "18px" }}>
                                            <i class="bi bi-eye-fill" style={{ color: "blue", cursor: "pointer" }} title="See" onClick={() => handleOpenSeeModal(sub)}></i>
                                    </div>

                                </td>

                                <td>
                                    {new Date(sub.createdat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td>

                                <td>
                                    {new Date(sub.lastupdatedat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" style={{ textAlign: "center" }}>
                                No records available...!
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <Modal
                show={showSeeModal}
                onHide={handleCloseSeeModal}
                backdrop="static"
                keyboard={false}
                fullscreen
            >
                <ValidatorSeePage isValidated={isValidated} userDetails={userDetails} handleCloseSeeModal={handleCloseSeeModal} setParentLoading={setParentLoading} />
            </Modal>

        </div>
    );
}

export default ValidatorSubmitted;